module.exports = __webpack_public_path__ + "img/436.e7f90394.jpg";